export default "__VITE_ASSET__Coa5d$zE__"